import React, { useEffect, useState } from 'react';
import axios from 'axios';
import styles from './userManagement.module.css';
import stylesDefault from '../default.module.css';
import { usePermissionGuard } from '../../adminPanelTools';
import { showErrorToast, showInfoToast, showWarningToast } from '../../../../code/ToastHelper';
export default function UserManagement() {
    const checking = usePermissionGuard('handle_users');
    const [users, setUsers] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [newUser, setNewUser] = useState({ email: '', first_name: '', family_name: '' });

    useEffect(() => {
        fetchUsers();
        fetchPermissions();
    }, []);

    const fetchUsers = async () => {
        setLoading(true);
        const token = localStorage.getItem('token'); // Or from your auth context/state

        try {
            const res = await axios.get('/api/users/', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setUsers(res.data);
        } catch (err) {
            console.error('Failed to fetch users:', err);
        } finally {
            setLoading(false);
        }
    };

    const fetchPermissions = async () => {
        const token = localStorage.getItem('token');
        try {
            const res = await axios.get('/api/permissions/', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setPermissions(res.data);
        } catch (err) {
            console.error('Failed to fetch permissions:', err);
        }
    };

    const createUser = async () => {
        if (!newUser.email || !newUser.first_name || !newUser.family_name) {
            showErrorToast('Bitte alle Felder ausfüllen!');
            return;
        }
        const token = localStorage.getItem('token');
        try {
            await axios.post('/api/users', newUser, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setNewUser({ email: '', first_name: '', family_name: '' });
            fetchUsers();
            showInfoToast('Ein neuer User wurde erstellt!');
        } catch (err) {
            console.error('Error creating user:', err);
            showErrorToast('Fehler beim Erstellen des Users!')
        }
    };

    const deleteUser = async (user) => {
        const confirm = window.confirm('Diesen Benutzer wirklich löschen?');
        if (!confirm) return;
        const token = localStorage.getItem('token');
        try {
            await axios.delete(`/api/users/${user.id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            fetchUsers();
            showWarningToast(`User: ${user.first_name} ${user.family_name} wurde gelöscht!`);

        } catch (err) {
            console.error('Fehler beim Löschen:', err);
            showErrorToast("Fehler beim Löschen.")
        }
    };

    const togglePermission = async (userId, permName, hasPerm) => {
        const token = localStorage.getItem('token');
        const userIndex = users.findIndex(u => u.id === userId);
        if (userIndex === -1) return;

        // Copy current permissions
        let updatedPermissions = [...users[userIndex].permissions];

        if (hasPerm) {
            updatedPermissions = updatedPermissions.filter(p => p !== permName);
        } else {
            updatedPermissions.push(permName);
        }

        try {
            await axios.put(
                `/api/users/${userId}/permissions`,
                { permissions: updatedPermissions },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            // Update local state without refetching all users
            setUsers(prevUsers => {
                const newUsers = [...prevUsers];
                newUsers[userIndex] = {
                    ...newUsers[userIndex],
                    permissions: updatedPermissions,
                };
                return newUsers;
            });
        } catch (err) {
            console.error('Permission update failed:', err);
            showErrorToast("Fehler beim Aktualisieren der Berechtigung!")
        }
    };


    if (checking) {
        return <div className={styles.container}><p>Lade...</p></div>; // or return null if you want no UI at all
    }
    return (
        <div className={stylesDefault.container}>
            <h1>Benutzerverwaltung</h1>

            {/* New User Form */}
            <div className={stylesDefault.form}>
                <h3>Neuen Benutzer anlegen</h3>
                <div className={styles.name}>
                    <input
                        type="text"
                        placeholder="Vorname"
                        value={newUser.first_name}
                        onChange={(e) => setNewUser({ ...newUser, first_name: e.target.value })}
                    />
                    <input
                        type="text"
                        placeholder="Nachname"
                        value={newUser.family_name}
                        onChange={(e) => setNewUser({ ...newUser, family_name: e.target.value })}
                    />
                </div>
                <input
                    type="email"
                    placeholder="E-Mail"
                    value={newUser.email}
                    onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
                />
                <div className={stylesDefault.formButtons}>
                    <button className={stylesDefault.blueButton} onClick={createUser}>Benutzer anlegen</button>
                </div>
            </div>

            {loading ? (
                <p>Lade Benutzer...</p>
            ) : (
                <div className={stylesDefault.tableWrapper}>
                    <table className={stylesDefault.table}>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>E-Mail</th>
                                <th>Berechtigungen</th>
                                <th>Aktion</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.length === 0 ? (
                                <tr><td colSpan="5">Keine Benutzer gefunden.</td></tr>
                            ) : users.map(user => (
                                <tr key={user.id}>
                                    <td>{user.first_name} {user.family_name}</td>
                                    <td>{user.email}</td>
                                    <td>
                                        <div className={styles.permissionsGrid}>
                                            {permissions.map(perm => {

                                                const hasPerm = user.permissions?.includes(perm.name);

                                                return (
                                                    <label key={perm.id} className={styles.tooltipWrapper}>
                                                        <input
                                                            className={styles.permInput}
                                                            type="checkbox"
                                                            checked={hasPerm}
                                                            onChange={() => togglePermission(user.id, perm.name, hasPerm)}
                                                        />
                                                        {perm.short}
                                                        <span className={styles.tooltipText}>{perm.description}</span>
                                                    </label>
                                                );
                                            })}
                                        </div>
                                    </td>
                                    <td>
                                        <button className={stylesDefault.redButton} onClick={() => deleteUser(user)}>
                                            Löschen
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
